import { render } from "./new_game.vue?vue&type=template&id=eb4ed46e"
import script from "./new_game.vue?vue&type=script&lang=js"
export * from "./new_game.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zekarim/Documents/HEIG/roesti-quiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__